<template>
<div>
  <div class="h-20">
    <div v-show="delayShow">
      <transition name="fade-enter">
        <button v-if="demo !== ('1')" id="submitResults" @click="putResults" type="submit" class="submitResults px-5 py-2">{{ text }}<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
        <button v-else id="restartActivity" @click="restartActivity" type="submit" class="submitResults px-5 py-2">Restart Demo<i aria-hidden="true" class="material-icons align-middle text-3xl">forward</i></button>
      </transition>
    </div>
  </div>
</div>
</template>

<script>
import VTooltip from 'v-tooltip'
import axios from 'axios'

  export default {
    props: {
      route:'',
      demo:'',
      text: {
        default: 'Continue',
      },
      resultsvalue: {
        default: 'done',
      },
      delay: {
        default: '4000'
      },
    },
    methods: {
      restartActivity() {
        $( ".submitResults").addClass( "loading" );
        location.reload();
      },
      putResults: function (event) {
        $( "#submitResults").addClass( "loading" );
        axios.put(this.route, { 
          results: ["done"]
        }).then(function (response) {
            console.log(response);
          }).then(function (event) {
            location.reload();
          })
      } 
    },
    data(){
      return{
        delayShow:false,
      }
    },
    created(){
      setTimeout(()=>{
        this.delayShow=true;
      },this.delay)
    }
  };
</script>
